module.exports = __webpack_public_path__ + "img/online-bg.a1502a67.png";